module.exports = __webpack_public_path__ + "img/marker.269e9b9d.svg";